import React from 'react';
import './Find.css'; // Import CSS for styling
import addImage from './image/add.svg'; // Path to your add image
import contactMap from './image/map_contact.svg';

const Find = () => {
  return (
    <div className="find-page">
      <div className="contact-info">
        <h1>Find us here</h1>
        <div className="info-section">
          <h2>Email</h2>
          <p>nashabandimaharajya@gmail.com</p>
        </div>
        <div className="info-section">
          <h2>Phone Number</h2>
          <p>Head Office: 09833394952</p>
          <p>Landline: 02235430142</p>
        </div>
        <div className="info-section">
          <h2>Address</h2>
          <p>218, 2nd Floor, Old Custom House, Shaheed Bhagat Singh Marg, Fort, Mumbai, 400001</p>
        </div>
      </div>
      <div className="map-image">
        <img src={contactMap} alt="Map" />
      </div>
    </div>
  );
};

export default Find;
